import ClientOAuth2, { Token } from 'client-oauth2';
import { push } from '@lagunovsky/redux-react-router';
import * as R from 'ramda';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { postAccessTokenToLoginIframe } from '../../App';
import { withFooter } from '../../reactutils/withFooter';
import { withMenu } from '../../reactutils/withMenu';
import { OAuthState } from '../../utils';
import { MenuBetting } from '../MenuBetting';
import { addSystemErrorMessage, setAuthenticatedUser } from '../System/actions';
import { getSystemConfig } from '../System/systemConfig';
import { Dispatch } from 'redux';

const redirectWithTimeout = (url: string, dispatch: Dispatch<any>, timeout: number) => {
    if (url.indexOf('http') !== -1) {
        // we need to set the token in the loginIframe here to enable redirects to the old webapp
        // with preserving the access token

        // and we need a small delay
        setTimeout(() => {
            window.location.href = url;
        }, timeout);
    } else {
        setTimeout(() => {
            dispatch(push(url));
        }, timeout);
    }
}

const LoginCallbackComp: React.FC<{}> = () => {
    const dispatch = useDispatch();

    const onError = (error: any) => {
        dispatch(addSystemErrorMessage(error));
    };
    const onSuccess = (user: Token) => {
        dispatch(setAuthenticatedUser(user));
    };

    React.useEffect(() => {
        let funtipOAuth = new ClientOAuth2({
            clientId: getSystemConfig().oauthClientId,
            clientSecret: '',
            accessTokenUri: getSystemConfig().oauthAuthenticationUri,
            authorizationUri: getSystemConfig().oauthAuthorizationUri,
            redirectUri: getSystemConfig().oauthRedirectUrl,
            scopes: getSystemConfig().oauthScopes
        });

        funtipOAuth.token
            .getToken(window.location.href)
            .then((token: Token) => {
                onSuccess(token);
                setTimeout(() => {
                    postAccessTokenToLoginIframe(token.accessToken);
                    if (token.data.state) {
                        const state: OAuthState = JSON.parse(token.data.state);
                        if (state !== undefined) {
                            const nextUrl = state.nextUrl ? state.nextUrl : '/betting';
                            console.info('forwarding to ' + nextUrl);
                            redirectWithTimeout(nextUrl, dispatch, 500);
                        } else {
                            redirectWithTimeout('/betting', dispatch, 500);
                        }
                    } else {
                        redirectWithTimeout('/betting', dispatch, 500);
                    }
                }, 500);
            })
            .catch(error => onError(error));
    });

    return <div>Login-callback</div>;
};

export const LoginCallback = R.compose(withMenu(<MenuBetting />), withFooter())(LoginCallbackComp);
